import { Component } from '@angular/core';

@Component({
  selector: 'app-ui-background',
  templateUrl: './ui-background.component.html',
  styleUrls: ['./ui-background.component.css']
})
export class UiBackgroundComponent {
  /**
   * Header button list show
   */
  Settingicon = true;
  Menuoption = 'center'
}
